import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/withdrawalconfirmmodal.css";
import { apiDelete } from "../../../utils/apiClient";

const WithdrawalConfirmModal = ({ onClose }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorType, setErrorType] = useState(null); // 'NOT_OWNER' | 'ORDER_EXISTS'

  // 회원 탈퇴 처리
  const handleWithdrawal = async () => {
    setIsLoading(true);
    setErrorType(null);

    try {
      const storeCode = JSON.parse(localStorage.getItem("user")).storeCode;
      const response = await apiDelete(`/store/withdrawal/${storeCode}`);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const message = errorData.message || "";

        if (message.includes("회원 정보가 일치하지 않습니다")) {
          setErrorType("NOT_OWNER");
        } else if (message.includes("주문이 존재하여 불가능합니다")) {
          setErrorType("ORDER_EXISTS");
        } else {
          alert("회원 탈퇴 처리 중 오류가 발생했습니다.");
        }
        setIsLoading(false);
        return;
      }

      // 탈퇴 성공 시
      setErrorType("SUCCESS");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
    } catch (error) {
      console.error("Error during withdrawal:", error);
      alert("회원 탈퇴 처리 중 오류가 발생했습니다.");
      setIsLoading(false);
    }
  };

  return (
    <div className="withdrawal-confirm-modal-overlay" onClick={onClose}>
      <div className="withdrawal-confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="withdrawal-confirm-modal-header">
          <h2>회원 탈퇴</h2>
          <button className="withdrawal-confirm-modal-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="withdrawal-confirm-modal-body">
          <div className="withdrawal-confirm-modal-warning">
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
              className="withdrawal-confirm-modal-warning-icon"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>

          {errorType === "SUCCESS" ? (
            <>
              <h3 className="withdrawal-confirm-modal-title">탈퇴 요청 완료</h3>
              <p className="withdrawal-confirm-modal-error-msg" style={{ color: "#374151" }}>
                탈퇴 요청이 정상적으로 접수되었습니다.<br /><br />
                탈퇴 철회를 원하실 경우 <strong>고객센터</strong>를 통해 요청해 주세요.
              </p>
            </>
          ) : errorType === "NOT_OWNER" ? (
            <>
              <h3 className="withdrawal-confirm-modal-title withdrawal-confirm-modal-error-title">탈퇴 불가</h3>
              <p className="withdrawal-confirm-modal-error-msg">회원 탈퇴는 점주만 할 수 있습니다.</p>
            </>
          ) : errorType === "ORDER_EXISTS" ? (
            <>
              <h3 className="withdrawal-confirm-modal-title withdrawal-confirm-modal-error-title">탈퇴 불가</h3>
              <p className="withdrawal-confirm-modal-error-msg">진행 중인 주문이 존재하여 탈퇴할 수 없습니다.<br />주문을 모두 처리한 후 다시 시도해 주세요.</p>
            </>
          ) : (
            <>
              <h3 className="withdrawal-confirm-modal-title">정말로 탈퇴하시겠습니까?</h3>
              <div className="withdrawal-confirm-modal-description">
                <p>회원 탈퇴 시 다음 사항을 유의해 주세요:</p>
                <ul>
                  <li>모든 회원 정보가 삭제됩니다.</li>
                  <li>진행 중인 주문이 있을 시 탈퇴가 불가능합니다.</li>
                  <li>멤버십 정보 및 결제 이력이 삭제됩니다.</li>
                  <li>탈퇴 요청일로부터 일주일 이내에 철회 가능하며, 이후에는 복구가 불가능합니다.</li>
                </ul>
              </div>
            </>
          )}
        </div>

        <div className="withdrawal-confirm-modal-footer">
          {errorType === "ORDER_EXISTS" ? (
            <>
              <button
                type="button"
                className="withdrawal-confirm-modal-btn withdrawal-confirm-modal-withdrawal-btn"
                onClick={() => { onClose(); navigate("/store/orderlist"); }}
              >
                매출 목록으로 이동
              </button>
              <button
                type="button"
                className="withdrawal-confirm-modal-btn withdrawal-confirm-modal-cancel-btn"
                onClick={onClose}
              >
                닫기
              </button>
            </>
          ) : errorType === "NOT_OWNER" ? (
            <button
              type="button"
              className="withdrawal-confirm-modal-btn withdrawal-confirm-modal-cancel-btn"
              onClick={onClose}
            >
              닫기
            </button>
          ) : errorType === "SUCCESS" ? (
            <button
              type="button"
              className="withdrawal-confirm-modal-btn withdrawal-confirm-modal-cancel-btn"
              onClick={() => navigate("/")}
            >
              확인
            </button>
          ) : (
            <>
              <button
                type="button"
                className="withdrawal-confirm-modal-btn withdrawal-confirm-modal-withdrawal-btn"
                onClick={handleWithdrawal}
                disabled={isLoading}
              >
                {isLoading ? "처리 중..." : "탈퇴"}
              </button>
              <button
                type="button"
                className="withdrawal-confirm-modal-btn withdrawal-confirm-modal-cancel-btn"
                onClick={onClose}
                disabled={isLoading}
              >
                취소
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default WithdrawalConfirmModal;
